const fhrRange = {
  gb: {
    max: 240,
    min: 30
  },
  abell: {
    max: 210,
    min: 50
  }
}

export default {
  fhrRange,
  origPointSize: 240,
  samplingRate: 4,
  // svg path
  svg: {
    fm: 'M5,7.86,1.55,9.13V1.79L5,3.06a.74.74,0,0,0,.51-1.39L1.06,0A.75.75,0,0,0,.38.11.75.75,0,0,0,.06.72V10.2a.75.75,0,0,0,.32.61.8.8,0,0,0,.42.13.75.75,0,0,0,.26,0L5.52,9.25A.73.73,0,0,0,6,8.3.74.74,0,0,0,5,7.86Z',
    // autoFM: 'M7.37,0H.67A.68.68,0,0,0,0,.71a.68.68,0,0,0,.66.7H3.22v8.74A.83.83,0,0,0,4,11H4a.82.82,0,0,0,.77-.86V1.41h2.6A.67.67,0,0,0,8,.71.68.68,0,0,0,7.37,0Z',
    autoFM: 'M4,11a.74.74,0,0,1-.74-.74V.8A.74.74,0,0,1,4.7.8v9.5A.74.74,0,0,1,4,11Z',
    tocoReset: 'M10,2.39l-3.75,4V1A1.15,1.15,0,0,0,5,0H5A1.15,1.15,0,0,0,3.79,1V6.37L0,2.39v8.19l3.75-4V12A1.15,1.15,0,0,0,5,13H5a1.15,1.15,0,0,0,1.24-1V6.6l3.75,4Z'
  }
}
